// Sparkle Cursor
document.addEventListener("mousemove", (e) => {
  const sparkle = document.createElement("div");
  sparkle.className = "cursor-sparkle";
  sparkle.style.left = e.pageX + "px";
  sparkle.style.top = e.pageY + "px";
  document.body.appendChild(sparkle);
  setTimeout(() => sparkle.remove(), 800);
});

document.addEventListener('DOMContentLoaded', function () {
  const hamburger = document.querySelector('.hamburger');
  if (hamburger) {
    hamburger.addEventListener('click', function () {
      document.body.classList.toggle('nav-open');
    });
  }
});


// Lightbox Demo Gallery (Reel Demos)
document.querySelectorAll(".reel-image").forEach(image => {
  image.addEventListener("click", () => {
    const modal = document.createElement("div");
    modal.className = "lightbox";
    modal.innerHTML = `
      <div class="lightbox-content">
        <img src="${image.src}" alt="Reel Demo">
        <button class="lightbox-close">×</button>
      </div>`;
    document.body.appendChild(modal);

    modal.querySelector(".lightbox-close").addEventListener("click", () => {
      modal.remove();
    });
  });
});

// Main Character Energy Phrase
const mcePhrases = [
  "Your vibe today: a ✨dreamy fae librarian✨",
  "Your energy: 🪄 forbidden spellbook hoarder 🪄",
  "Main character moment: 💖 cursed princess with a prophecy 💖",
  "Reading like you're 🍷 the villain’s favorite weakness 🍷",
  "Serving 🔥 fire-wielding warrior in a velvet cloak 🔥",
  "Today you're a 🌸 cottagecore witch with secrets 🌸",
  "You're glowing like 🌙 the moon-blessed oracle 🌙",
  "You’ve entered 🗝️ the enemies-to-lovers prophecy arc 🗝️",
  "Manifesting 💔 morally gray men and glitter 💔",
  "Living like you're 💌 the chosen one with pink gel pens 💌"
];

const mceDisplay = document.querySelector(".main-character-energy");
if (mceDisplay) {
  const random = Math.floor(Math.random() * mcePhrases.length);
  mceDisplay.innerText = mcePhrases[random];
}

// Mood Filter Grid
document.querySelectorAll("[data-mood]").forEach(button => {
  button.addEventListener("click", () => {
    const tag = button.dataset.mood;
    const scrollTarget = document.querySelector(`[data-section="filtered-products"]`);
    if (scrollTarget) scrollTarget.scrollIntoView({ behavior: "smooth" });

    document.querySelectorAll(".product-card").forEach(card => {
      if (card.dataset.tags.includes(tag)) {
        card.style.display = "block";
      } else {
        card.style.display = "none";
      }
    });
  });
});

// Random Portal Button
const portalButton = document.querySelector("#random-portal");
if (portalButton) {
  portalButton.addEventListener("click", () => {
    const magicItems = document.querySelectorAll('.product-card[data-tags*="magical-pick"]');
    if (magicItems.length) {
      const random = Math.floor(Math.random() * magicItems.length);
      window.location.href = magicItems[random].querySelector("a").href;
    }
  });
}

// Scroll-triggered animation
const observer = new IntersectionObserver(entries => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add("visible");
    }
  });
}
);



